import React from 'react';
import { formatRelativeActive } from '../services/photoHelpers';

/**
 * Small green dot + optional label indicating online status.
 * Props:
 *   - isOnline: boolean
 *   - lastActive: ISO string (used when not online to show "Active Xm ago")
 *   - showLabel: boolean (default true)
 *   - size: dot size in px (default 10)
 */
const OnlineDot = ({ isOnline, lastActive, showLabel = true, size = 10, className = '' }) => {
  const label = isOnline ? 'Online now' : formatRelativeActive(lastActive);
  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`} data-testid="online-status">
      <span
        className={`inline-block rounded-full ${isOnline ? 'bg-emerald-500' : 'bg-gray-300'}`}
        style={{ width: size, height: size, boxShadow: isOnline ? '0 0 0 3px rgba(16,185,129,0.15)' : undefined }}
      />
      {showLabel && label && (
        <span className={`text-xs ${isOnline ? 'text-emerald-600 font-medium' : 'text-gray-500'}`}>{label}</span>
      )}
    </div>
  );
};

export default OnlineDot;
